<template>
  <div style="width: 100%">
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar" v-bind:color="snackbarkColor"></snackbarcomp>
    <div v-if="isDomesticRT">
      <DomesticRT :flights="displayGidislerList" :displayGidislerList="displayGidislerList" :displayDonuslerList="displayDonuslerList" :ticketMarkup="ticketMarkup" :FlightType="'RT'" :currency="currency"/>
    </div>
    <div v-else-if ="FlightType == 'RT'">
      <RT :flights="displayTicketList" :ticketMarkup="ticketMarkup" :FlightType="'RT'" :currency="currency"></RT>
    </div>
    <div v-else>
      <OW :flights="displayTicketList" :ticketMarkup="ticketMarkup" :FlightType="'OW'" :currency="currency"></OW>
    </div>

    <v-layout row justify-center>
      <v-dialog v-model="dialogUserInfo" persistent max-width="490">
        <v-card>
          <v-card-title class="headline primary white--text">
            Arkman - Sem Bilet
            <v-spacer></v-spacer>
            <v-btn flat icon color="primary" @click.native="dialogUserInfo = false">
              <v-icon class="white--text">cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="userInfoForm">
              <v-text-field :label="$t('Username')" :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userName"></v-text-field>
              <v-text-field :label="$t('Telephone')" :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userPhone"></v-text-field>
              <v-text-field :label="$t('Email_label')" :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userMail"></v-text-field>
              <v-text-field label="Mesaj" v-model="userInfo.Message" textarea></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="sendEmail()">{{
              $t("Send")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import logoo from "../../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import axios from "axios";
import auth from "@/api/auth.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import PegasusFareFeatures from "./comp/Fare/PegasusFareFeatures.vue";
import AjetFareFeatures from "./comp/Fare/AjetFareFeatures.vue";
import THYFareFeatures from "./comp/Fare/THYFareFeatures.vue";
import RT from "./RT/RT.vue";
import OW from "./OW/OW.vue";
import DomesticRT from "./RT/DomesticRT.vue";
import { resolveFlightTotalFare } from "./comp/fareCurrency";
export default {
  props: {
    ticketList: {
      type: Array,
    },
    FlightType: {
      type: String,
    },
    isActive: {
      type: Boolean,
    },
    isDomesticRT: {
      type: Boolean,
    },
    currency: {
      type: String,
      default: 'TRY',
    },
  },
  components: {
    loadingcomp,
    snackbarcomp,
    PegasusFareFeatures,
    AjetFareFeatures,
    THYFareFeatures,
    RT,
    OW,
    DomesticRT,
  },
  data() {
    return {
      snackbarkColor: null,
      text1: null,
      snackbar: false,
      cardViewGidis: false,
      tableViewGidis: false,
      otherPricesGidis: false,
      domesticRTpickGidisItem: null,
      domesticRTpickDonusItem: null,
      domesticRTselectedGidisFareCode: '',
      domesticRTselectedDonusFareCode: '',
      dialogpickitem: false,
      pickeditem: null,
      selectedFareCode: '',
      loadingvmodel: false,
      otherPricesList: [],
      otherPrices: false,
      dialogAds: false,
      headersSummary: [
        {
          text: this.$t("Airline"),
          sortable: false,
        },
        {
          text: this.$t("Flight"),
          sortable: false,
        },
        {
          text: this.$t("Departure-TWO"),
          sortable: false,
        },
        {
          text: this.$t("Arrival"),
          sortable: false,
        },
        {
          text: this.$t("Plane-Type"),
          sortable: false,
        },
        {
          text: this.$t("Cabin"),
          sortable: false,
        },
        {
          text: this.$t("Seat"),
          sortable: false,
        },
      ],
      headers: Airports.headersSummary(),
      ticketMarkup: 0,
      openedPanel: null,
      cardView: false,
      tableView: false,
      allocated: Airports.allocateParams(),
      allocateItems: Airports.allocateItems(),
      userInfo: {
        userName: null,
        userPhone: null,
        userMail: null,
        Message: null,
      },
      dialogUserInfo: false,
      upSellTicket: {},
      expandedGroupOthersIdx: null,
      expandedGidisGroupIdx: null,
      expandedDonusGroupIdx: null,
      expandedOtherDetailKey: null,
    };
  },
  computed: {
    displayTicketList() {
      var a = this.groupTickets(this.ticketList);
      return a;
    },
    displayGidislerList() {
      var list =  this.ticketList.filter(function(t) { return t.FlightSegments.some(function(s) { return s.DirectionInd === 0; }); });
      return this.groupTickets(list);
    },
    displayDonuslerList() {
      var list = this.ticketList.filter(function(t) { return t.FlightSegments.some(function(s) { return s.DirectionInd === 1; }); })
       
      return this.groupTickets(list);
    },
  },
  methods: {

    groupTickets(list) {
      var self = this;
      var groups = {};
      var order = [];
      list.forEach(function(ticket) {
        var key = ticket.FlightSegments.map(function(seg) {
          var numPart = String(seg.FlightNumber || '').replace(/\D/g, '');
          return numPart + '_' + (seg.MarkettingAirline || '');
        }).join('|');
        if (!groups[key]) {
          groups[key] = { primary: ticket, others: [] };
          order.push(key);
        } else {
          var fare = self.getTicketFare(ticket);
          var cheapFare = self.getTicketFare(groups[key].primary);
          if (fare < cheapFare) {
            groups[key].others.push(groups[key].primary);
            groups[key].primary = ticket;
          } else {
            groups[key].others.push(ticket);
          }
        }
      });
      return order.map(function(k) {
        var g = groups[k];
        return Object.assign({}, g.primary, { _groupOthers: g.others });
      }).sort(function(a, b) {
        return self.getTicketFare(a) - self.getTicketFare(b);
      });
    },
    getTicketFare(ticket) {
      return Number(resolveFlightTotalFare(ticket, this.currency)) || 0;
    },

    sendEmail() {
      if (this.$refs.userInfoForm.validate()) {
        let formData = new FormData();
        var mailText =
          "Kullanici Adi = " +
          this.userInfo.userName +
          " | Telefon = " +
          this.userInfo.userPhone +
          " | Mail =  " +
          this.userInfo.userMail +
          " | Mesaj = " +
          this.userInfo.Message +
          " ";

        formData.append("Konu", "Sem Bilet Arkman Entegrasyon Talebi");
        formData.append("to", "demirarkman@arkman.com.tr");
        formData.append("formattedMessage", mailText);
        formData.append("mailType", "0");
        axios.defaults.baseURL = auth.API_URL;
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        axios
          .post(auth.API_URL + "api/Helpers/SendEmail", formData, {
            headers: {},
          })
          .then((response) => {
            if (response.data == true) {
              this.dialogUserInfo = false;
            }
          })
          .catch(function () { });
      }
    },

 



  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style scoped>
.openCardListTile {
  height: auto;
  white-space: normal;
  overflow: visible;
}

.provider-span {
  text-align: center;
  padding-left: 12px;
  font-style: italic;
  color: rgb(114, 95, 95);
}
</style>